import React, { memo } from 'react'
import { Button } from 'antd'
import { ImagePreview } from '../../../../../../components'
import { COLORS } from './utils'

const ActiveReferencesBar = memo(
  ({ references, onAnnotate, onOpenReferences, disabled }) => {
    if (!references.length) return null

    return (
      <div
        style={{
          border: `1px solid ${COLORS.borderLight}`,
          borderRadius: 8,
          background: COLORS.white,
          padding: '10px 12px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          minHeight: 82
        }}
      >
        <div style={{ minWidth: 96 }}>
          <div
            style={{
              fontSize: 11,
              color: COLORS.textMuted,
              textTransform: 'uppercase',
              lineHeight: 1.2
            }}
          >
            References
          </div>
          <Button
            size="small"
            icon="picture"
            onClick={onOpenReferences}
            disabled={disabled}
            style={{ marginTop: 6 }}
          >
            Change
          </Button>
        </div>

        <div
          style={{
            flex: 1,
            minWidth: 0,
            display: 'grid',
            gridAutoFlow: 'column',
            gridAutoColumns: 64,
            gap: 8,
            overflowX: 'auto',
            paddingBottom: 2
          }}
        >
          {references.map((url, index) => (
            <div
              key={`${url}-${index}`}
              style={{
                position: 'relative',
                width: 64,
                height: 64,
                borderRadius: 8,
                overflow: 'hidden',
                border:
                  index === 0
                    ? `2px solid ${COLORS.primary}`
                    : `1px solid ${COLORS.borderLight}`,
                background: COLORS.background,
                flexShrink: 0
              }}
            >
              <ImagePreview
                src={url}
                alt={
                  index === 0 ? 'Current reference' : `Reference ${index + 1}`
                }
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block'
                }}
              />

              <div
                style={{
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  bottom: 0,
                  padding: '14px 3px 3px',
                  background: 'linear-gradient(transparent, rgba(0,0,0,0.58))',
                  color: COLORS.white,
                  fontSize: 9,
                  textAlign: 'center',
                  pointerEvents: 'none'
                }}
              >
                {index === 0 ? 'Current' : `Ref ${index}`}
              </div>

              <Button
                size="small"
                shape="circle"
                icon="highlight"
                aria-label={
                  index === 0
                    ? 'Annotate current image'
                    : `Annotate reference ${index}`
                }
                onClick={event => {
                  event.stopPropagation()
                  onAnnotate(url)
                }}
                disabled={disabled}
                style={{
                  position: 'absolute',
                  top: 4,
                  right: 4,
                  width: 22,
                  height: 22,
                  minWidth: 22,
                  padding: 0,
                  background: 'rgba(255,255,255,0.94)',
                  border: 'none',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.14)'
                }}
              />
            </div>
          ))}
        </div>
      </div>
    )
  }
)

export default ActiveReferencesBar
